/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Widget_Load_ErrorInputs */

const en_dashboard_widget_load_error = /** @type {(inputs: Dashboard_Widget_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This dashboard widget could not be loaded.`)
};

const pt_br2_dashboard_widget_load_error = /** @type {(inputs: Dashboard_Widget_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar este indicador.`)
};

/**
* | output |
* | --- |
* | "This dashboard widget could not be loaded." |
*
* @param {Dashboard_Widget_Load_ErrorInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dashboard_widget_load_error = /** @type {((inputs?: Dashboard_Widget_Load_ErrorInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Widget_Load_ErrorInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_widget_load_error(inputs)
	return pt_br2_dashboard_widget_load_error(inputs)
});